import { render } from "./ShipCustomFields.vue?vue&type=template&id=3077403c&scoped=true"
import script from "./ShipCustomFields.vue?vue&type=script&lang=js"
export * from "./ShipCustomFields.vue?vue&type=script&lang=js"

import "./ShipCustomFields.vue?vue&type=style&index=0&id=3077403c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3077403c"]])

export default __exports__